/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterLosses } from '../types/Order'
import { defaultFormatTimeZone } from '../utils/consts'

interface LossesFiltersContextType {
  filters: FilterLosses
  setFilters: (filters: FilterLosses) => any
}
const initialState: LossesFiltersContextType = {
  filters: {
    dateRange: {
      initialDate: moment().clone().subtract(6, 'months').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-losses-portal-analytics_v2'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const LossesFiltersContext = createContext(initialState)

const LossesFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <LossesFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </LossesFiltersContext.Provider>)
}

export default LossesFiltersContextProvider
